import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import { Field, useFormikContext } from 'formik';
import { enums } from 'helpers';
import React, { memo } from 'react';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';

import type { IFieldsTestWebHook } from 'v2/interfaces/webhook/webhook';

import styles from '../styles';

const Fields = memo(() => {
  const classes = styles();
  const { values, isSubmitting, setFieldValue, resetForm, initialValues } = useFormikContext<IFieldsTestWebHook>();

  const selectTypes = [
    {
      label: 'Fatura',
      value: 'invoice',
    },
    {
      label: 'Contrato',
      value: 'contract',
    },
    {
      label: 'Abandono de carrinho',
      value: 'abandonment',
    },
  ];

  const solveStatus = () => {
    if (values.type === 'invoice') {
      // ????
      return Object.keys(enums.INVOICE_STATUS_NAME)
        .filter((id) => ![0, 2, 5, 8, 12, 13, 14].includes(Number.parseInt(id)))
        .map((id) => ({
          label: enums.INVOICE_STATUS_NAME[Number.parseInt(id)],
          value: Number.parseInt(id),
        }));
    }

    return Object.keys(enums.SUBSCRIPTIONS_STATUS_NAME).map((id) => ({
      label: enums.SUBSCRIPTIONS_STATUS_NAME[Number.parseInt(id)],
      value: Number.parseInt(id),
    }));
  };

  const onChangeType = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue('type', e.target.value);
    setFieldValue('status', 1);
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Field
          id='type'
          name='type'
          label='Tipo'
          fullWidth
          options={selectTypes}
          component={SelectFormField}
          onChange={onChangeType}
          disabled={initialValues.type === 'abandonment'}
        />
      </Grid>

      <Grid item xs={12}>
        <br />
      </Grid>
      {values.type !== 'abandonment' && (
        <Grid item xs={12}>
          <Field id='status' name='status' label='Status' fullWidth component={SelectFormField} options={solveStatus()} />
        </Grid>
      )}

      <Grid item xs={12}>
        <div className={classes.alignRight}>
          <Button disabled={isSubmitting} onClick={() => resetForm()}>
            Cancelar
          </Button>

          <Button
            disabled={isSubmitting}
            type='submit'
            variant='contained'
            color='secondary'
            startIcon={isSubmitting && <CircularProgress size={16} />}
          >
            Enviar teste
          </Button>
        </div>
      </Grid>
    </Grid>
  );
});

export default Fields;
